module.exports = __webpack_public_path__ + "img/check.78980f4d.png";